import type { ProcessingJob } from '../types';

/**
 * Statuses in which a job is still making progress on its own, so the detail
 * view must keep polling for updates (M7). Excludes terminal states
 * (completed / failed / cancelled / completed_with_errors) and states awaiting
 * user action (suspended = paused until the user resumes; awaiting_validation =
 * waiting on the reviewer). Kept here as the single source of truth so any
 * other component reusing the poll-or-stop decision stays in sync — do not
 * inline the status list at call sites (spec §3.1).
 */
export const PRE_TERMINAL_STATUSES: ReadonlyArray<ProcessingJob['status']> = [
  'pending',
  'queued',
  'processing',
];

export const isPreTerminalStatus = (
  status: ProcessingJob['status'] | string | undefined | null,
): boolean =>
  status != null && (PRE_TERMINAL_STATUSES as ReadonlyArray<string>).includes(status);
